export default "__VITE_ASSET__9fef1487__"